if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this._onButtonClick = this._handleButtonClick.bind(this);
      this._onInputKeydown = this._handleInputKeydown.bind(this);
      this._onInputBlur = this._handleInputBlur.bind(this);
      this._isLoading = false;
    }

    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.buttons = this.querySelectorAll('button[data-action]');

      if (!this.input) return;

      // Store the initial server-rendered value as the known-good baseline
      this.input.dataset.previousValue = this.input.value;

      this.buttons.forEach(btn => btn.addEventListener('click', this._onButtonClick));
      this.input.addEventListener('keydown', this._onInputKeydown);
      this.input.addEventListener('blur', this._onInputBlur);
    }

    disconnectedCallback() {
      if (this.buttons) {
        this.buttons.forEach(btn => btn.removeEventListener('click', this._onButtonClick));
      }
      if (this.input) {
        this.input.removeEventListener('keydown', this._onInputKeydown);
        this.input.removeEventListener('blur', this._onInputBlur);
      }
    }

    // ── Public API ──

    get value() {
      return parseInt(this.input?.value) || 0;
    }

    set value(val) {
      if (this.input) {
        this.input.value = val;
        this.input.dataset.previousValue = val;
      }
    }

    get key() {
      return this.dataset.key || '';
    }

    set loading(isLoading) {
      this._isLoading = isLoading;
      const cartItem = this.closest('.cart-item');
      if (!cartItem) return;

      if (isLoading) {
        cartItem.style.opacity = '0.6';
        cartItem.style.pointerEvents = 'none';
      } else {
        cartItem.style.opacity = '';
        cartItem.style.pointerEvents = '';
      }
    }

    get loading() {
      return this._isLoading;
    }

    revert() {
      if (this.input) {
        this.input.value = this.input.dataset.previousValue || 1;
      }
    }

    // ── Private handlers ──

    _handleButtonClick(e) {
      if (this._isLoading) return;

      const action = e.currentTarget.dataset.action;
      const currentValue = this.value;

      if (action === 'plus') {
        this.input.value = currentValue + 1;
      } else {
        this.input.value = Math.max(0, currentValue - 1);
      }

      this._dispatchChange();
    }

    _handleInputKeydown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.input.blur();
      }
    }

    _handleInputBlur() {
      const newValue = this.value;
      const prevValue = parseInt(this.input.dataset.previousValue) || 0;
      if (newValue !== prevValue) {
        this._dispatchChange();
      }
    }

    _dispatchChange() {
      this.dispatchEvent(new CustomEvent('quantity-change', {
        bubbles: true,
        detail: {
          key: this.key,
          quantity: this.value
        }
      }));
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
